module.exports = __webpack_public_path__ + "assets/ep19.png";